
import { CssBaseline, ThemeProvider } from "@mui/material";
import AllRoutes from "./routes";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./store";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";
import theme from "./theme";
import { fetchSettingsDetails } from "./store/slices/settings";
import { loadFont } from "./shared/utils";
import { THEME_COLOR } from "./shared/constants/colors";
import "./App.css"
function App() {
 
  const dispatch =useDispatch();
  const settingsData = useSelector(
    (state: any) => state?.settings?.settingsData
  );
  useEffect(() => {
    dispatch(fetchSettingsDetails());
  }, [dispatch]);
 
  useEffect(() => {
    if (settingsData?.FONT_LINK) {
      loadFont(settingsData?.FONT_LINK);
    }
  }, [settingsData?.FONT_LINK]);

  const Customtheme = theme(settingsData);

  return (
    
    <ThemeProvider theme={Customtheme}>
    {/* <Provider store={store}> */}
    <Toaster  toastOptions={{
    // duration: 5000,
    style: {
      background: settingsData?.PRIMARY_COLOR || THEME_COLOR,
      color: '#fff',
    }}}/>
      <CssBaseline>
        <AllRoutes />
      </CssBaseline>
      {/* </Provider> */}
    </ThemeProvider>
  );
}

export default App;
